import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, Link } from "react-router-dom";
import axios from "axios";
import * as XLSX from 'xlsx-js-style';
import { saveAs } from 'file-saver';
import { format } from "../../intl.js";

import moment from "moment";
import {
  getProfilesByUser,
  updateProfile,
  getProfile,
} from "../../actions/profile";
import {
  useMediaQuery,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableContainer,
  TableFooter,
  TablePagination,
  TableRow,
  Paper,
  IconButton,
  Container,
  TextField,
  CircularProgress,
  FormControl,
  makeStyles,
  useTheme,
  createTheme,
  ThemeProvider,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import PropTypes from "prop-types";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import ClearIcon from "@material-ui/icons/Clear";
import { getAllClients } from "../../actions/clientActions";
import DeleteOutlineRoundedIcon from "@material-ui/icons/DeleteOutlineRounded";
import RemoveRedEyeOutlinedIcon from "@material-ui/icons/RemoveRedEyeOutlined";
import Autocomplete from "@material-ui/lab/Autocomplete";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import { useLocation } from "react-router-dom";

import ProgressButton from "react-progress-button";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import {
  deleteInvoice,
  getInvoicesByUser,
  getInvoices,
  getInvoicesByPage,
} from "../../actions/invoiceActions";
import { getUsers } from "../../actions/auth";
import NoData from "../svgIcons/NoData";
import Spinner from "../Spinner/Spinner";
import { useSnackbar } from "react-simple-snackbar";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import GetAppIcon from "@material-ui/icons/GetApp";

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const useStyles2 = makeStyles((_theme) => ({
  table: {
    minWidth: 500,
  },

  tablecell: {
    fontSize: "16px",
  },
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "20px",
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  typography: {
    fontSize: "18px",
    fontWeight: 500,
  },
}));

const tableStyle = {
  width: 160,
  fontSize: 18,
  cursor: "pointer",
  borderBottom: "none",
  padding: "4px",
  textAlign: "center",
};
const headerStyle = {
  borderBottom: "none",
  textAlign: "center",
  fontSize: "22px",
};
const colorTheme = createTheme({
  palette: {
    primary: {
      main: "#ef7f1a",
    },
  },
});

const Invoices = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [downloadStatus, setDownloadStatus] = useState(null);
  const user = JSON.parse(localStorage.getItem("profile"));
  const { invoices, totalInvoices, totalPages } = useSelector(
    (state) => state.invoices.invoices
  );

  // //(invoices);
  const [rows, setRows] = useState([]);
  const { users } = useSelector((state) => state.auth);
  const { profiles } = useSelector((state) => state.profiles);
  const clients = useSelector((state) => state.clients.clients);
  // //(users);
  // //(rows);
  const [loading, setLoading] = useState(false);
  const isLoading = useSelector((state) => state.invoices.isLoading);
  const [searchQuery, setSearchQuery] = useState("");
  const [salesperson, setSalesperson] = useState(null);
  const [party, setParty] = useState(null);
  // eslint-disable-next-line
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const [startDate, setStartDate] = useState(moment().toDate());
  const [endDate, setEndDate] = useState(moment().toDate());
  const [selectedFilter, setSelectedFilter] = useState("");
  const classes = useStyles2();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  // const rows = []

  // useEffect(() => {
  //     dispatch(getInvoices());
  // }, [dispatch]);

  useEffect(() => {
    dispatch(getInvoicesByPage(page, rowsPerPage));
  }, [dispatch, page, rowsPerPage]);
  useEffect(() => {
    if (invoices?.length > 0) {
      setRows(invoices);
    }
  }, [invoices]);
  useEffect(() => {
    dispatch(getUsers());
  }, [location]);
  useEffect(() => {
    // dispatch(getProfilesByUser({ search: user?.result?._id }))
    dispatch(getProfile(user?.userProfile?._id));
  }, [location, dispatch]);
  useEffect(() => {
    dispatch(
      // getClientsByUser({ search: user?.result._id || user?.result?.googleId })
      getAllClients()
    );

    // eslint-disable-next-line
  }, [dispatch]);

  useEffect(() => {
    console.log("Invoices Booking Data Per Page... ------------:", invoices);
  }, [invoices]);

  useEffect(() => {
    console.log("Invoices Booking Total Data... ------------:", totalInvoices);
  }, [totalInvoices]);
  const toCommas = (value) => {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  // useEffect(() => {
  //   if (user?.result?.userType === "user") {
  //     const rows = invoices.filter(
  //       (inv) => inv.creator[0] === user?.result?._id
  //     );
  //     setRows( rows.filter(filterByDateRange));
  //   } else {
  //     setRows(invoices.filter(filterByDateRange));
  //   }
  // }, );
  const findUserNameById = (userId) => {
    // //("parameter" + userId);
    const user = users.find((user) => user._id == userId);
    // //(user);
    return user ? user.name : "";
  };

  const filterByDateRange = (invoice) => {
    if (!startDate || !endDate || !moment(startDate).isValid() || !moment(endDate).isValid()) {
      return true; // Show all invoices if dates are invalid or not set
    }
    const invoiceDate = moment(invoice.date).startOf('day');
    const start = moment(startDate).startOf('day');
    const end = moment(endDate).startOf('day');
    return invoiceDate.isBetween(start, end, 'day', '[]') || invoiceDate.isSame(start, 'day') || invoiceDate.isSame(end, 'day');
  };
  // const filteredRows = rows;
  const filteredRows = rows.filter((row) => {
    // debugger;
    const isSalespersonFilter = selectedFilter === "salesperson";
    const searchQueryLowerCase =
      searchQuery && typeof searchQuery === "string"
        ? searchQuery.toLowerCase()
        : "";

    if (isSalespersonFilter) {
      const creatorName = findUserNameById(row.creator).toLowerCase();
      return (
        filterByDateRange(row) && creatorName.includes(searchQueryLowerCase)
      );
    } else {
      const clientName = row.client.agentCode.toLowerCase();

      return (
        filterByDateRange(row) && clientName.includes(searchQueryLowerCase)
      );
    }
  });

  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleFilterChange = (event) => {
    setSelectedFilter(event.target.value); // Update the selected filter when the user changes the option
  };
  const editInvoice = (id) => {
    history.push(`/edit/invoice/${id}`);
  };
  const handleDelete = (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this client?"
    );
    if (confirmDelete) {
      dispatch(deleteInvoice(id, openSnackbar));
    }
  };

  const openInvoice = (id) => {
    history.push(`/invoice/${id}`);
  };
  const createAndDownloadXlsx = () => {
    // Check if there are filtered rows
    if (filteredRows.length) {
      // Determine unique items from selling array across all rows
      const uniqueItems = [...new Set(filteredRows.flatMap(row => 
        row.selling.map(item => item.itemName)
      ))];
  
      // Prepare the data for Excel export
      const exportData = filteredRows.map(row => {

        // Compute Expense Description
      const expenseDescription = row.payable.map((item, index) => {
        const total = Number(item.unitPrice) * Number(item.quantity);
        return `(${index + 1}) ${item.itemName}, Total: ${total}`;
      }).join('\n');

      // Compute Commission Description
      const commissionDescription = row.selling.map((item, index) => {
        const total = Number(item.unitPrice) * Number(item.quantity);
        return `(${index + 1}) ${item.itemName}, Total: ${total}`;
      }).join('\n');
        // Create a base object with standard columns
        const baseData = {
          'Booking No': row.invoiceNumber || '',
          'Date': row.date ? moment(row.date).format("DD-MM-YYYY") : '',
          'Agent': row.client.name || '',
          'Nationality': row.nationality || '',
          'Hotel': row.hotel || '',
          'Pax': (row.adult + row.child) || '',
          'Commission': row.commission || '',
        'Commission Description': commissionDescription || '' ,// New column
          'Expense': row.expense || '',
          'Expense Description': expenseDescription || '', // New column
          'Amount': row.total || '',
          'Guest Code': row.guestCode || '',
          'Adult': row.adult || '',
          'Child': row.child || ''
        };
  
        // Add dynamic columns for selling items
        uniqueItems.forEach(itemName => {
          const matchedItem = row.selling.find(item => item.itemName === itemName);
          baseData[itemName] = matchedItem ? matchedItem.quantity : '';
        });
  
        return baseData;
      });
  
      // Create worksheet
      const worksheet = XLSX.utils.json_to_sheet(exportData);
  
      // Style for headers
      const headerStyle = {
        fill: { fgColor: { rgb: 'D3D3D3' } }, // Light grey background
        font: { 
          color: { rgb: '#000000' }, // White text
          bold: true // Optional: make headers bold
        },
        alignment: { horizontal: 'center' } // Optional: center align headers
      };

      const dateStyle = {
        numFmt: 'dd-mm-yyyy'
      };

      const descriptionStyle = {
        alignment: { wrapText: true } // Enable text wrapping for descriptions
      };
  
      // Apply styles and calculate column widths
      const range = XLSX.utils.decode_range(worksheet['!ref']);
      const colWidths = [];
  
      for (let col = range.s.c; col <= range.e.c; col++) {
        const headerCell = XLSX.utils.encode_cell({ r: 0, c: col });
        if (worksheet[headerCell]) {
          worksheet[headerCell].s = headerStyle;
        }
  
        // Apply date style to 'Date' column (column index 1)
        if (col === 1) {
          for (let row = 1; row <= range.e.r; row++) {
            const cell = XLSX.utils.encode_cell({ r: row, c: col });
            if (worksheet[cell]) {
              worksheet[cell].s = dateStyle;
            }
          }
        }
  
        // Apply description style to 'Expense Description' and 'Commission Description' columns
        const headerValue = worksheet[XLSX.utils.encode_cell({ r: 0, c: col })].v;
        if (headerValue === 'Expense Description' || headerValue === 'Commission Description') {
          for (let row = 1; row <= range.e.r; row++) {
            const cell = XLSX.utils.encode_cell({ r: row, c: col });
            if (worksheet[cell]) {
              worksheet[cell].s = descriptionStyle;
            }
          }
        }
  
        // Calculate max width for each column
        let maxWidth = String(headerValue).length;
        for (let row = 1; row <= range.e.r; row++) {
          const cell = XLSX.utils.encode_cell({ r: row, c: col });
          if (worksheet[cell] && worksheet[cell].v) {
            const cellValue = String(worksheet[cell].v);
            const lines = cellValue.split('\n');
            const maxLineLength = Math.max(...lines.map(line => line.length));
            maxWidth = Math.max(maxWidth, maxLineLength);
          }
        }
        colWidths.push({ wch: Math.min(maxWidth + 2, 50) }); // Limit max width to 50 characters
      }
  
      // Set column widths
      worksheet['!cols'] = colWidths;
  
      // Create workbook and save
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Booking Report');
  
      const currentDate = new Date();
      const filename = `BookingReport_${currentDate.toISOString().split('T')[0]}.xlsx`;
  
      try {
        XLSX.writeFile(workbook, filename);
        openSnackbar("Export successful");
      } catch (error) {
        console.error("Export failed", error);
        openSnackbar("Export failed");
      }
    } else {
      openSnackbar("No records to export");
    }
  
    //   // Apply header styling to all column headers
    //   const range = XLSX.utils.decode_range(worksheet['!ref']);
    //   for (let col = range.s.c; col <= range.e.c; col++) {
    //     const headerCell = XLSX.utils.encode_cell({ r: 0, c: col });
    //     if (worksheet[headerCell]) {
    //       worksheet[headerCell].s = headerStyle;
    //     }
    //   }
  
    //   // Create workbook and add worksheet
    //   const workbook = XLSX.utils.book_new();
    //   XLSX.utils.book_append_sheet(workbook, worksheet, 'Booking Report');
  
    //   // Generate current date for filename
    //   const currentDate = new Date();
    //   const filename = `BookingReport_${currentDate.toISOString().split('T')[0]}.xlsx`;
  
    //   // Write to file and save
    //   try {
    //     XLSX.writeFile(workbook, filename);
        
    //     // Optional: Show success notification
    //     openSnackbar("Export successful");
    //   } catch (error) {
    //     // Handle any export errors
    //     console.error("Export failed", error);
    //     openSnackbar("Export failed");
    //   }
    // } else {
    //   // Show error if no records
    //   openSnackbar("No records to export");
    // }
  };
  // const createAndDownloadPdf = () => {
  //   //(rows);
  //   //(filteredRows);
  //   setLoading(true);

    
  //   if (filteredRows.length) {
  //     setDownloadStatus("loading");
  //     // Enhance filteredRows with expense and commission descriptions
  //   const enhancedRows = filteredRows.map(row => ({
  //     ...row,
  //     expenseDescription: row.payable.map((item, index) => {
  //       const total = Number(item.unitPrice) * Number(item.quantity);
  //       return `(${index + 1}) ${item.itemName}, Total: ${total}`;
  //     }).join('\n'),
  //     commissionDescription: row.selling.map((item, index) => {
  //       const total = Number(item.unitPrice) * Number(item.quantity);
  //       return `(${index + 1}) ${item.itemName}, Total: ${total}`;
  //     }).join('\n')
  //   }));
  //     axios
  //       .post(`${process.env.REACT_APP_API}/create-report`, {
  //         filteredRows: enhancedRows,
  //         users,
  //         searchQuery,
  //         profiles: profiles,
  //         startDate,
  //         endDate
  //         // totalAmount,
  //       })
  //       .then(() =>
  //         axios.get(`${process.env.REACT_APP_API}/fetch-report`, {
  //           responseType: "blob",
  //         })
  //       )
  //       .then((res) => {
  //         const pdfBlob = new Blob([res.data], { type: "application/pdf" });
  //         // const downloadUrl = window.URL.createObjectURL(pdfBlob);
  //         // setDownloadStatus("success");
  //         // window.open(downloadUrl, "_blank");
  //         const currentDate = new Date();

  //         saveAs(pdfBlob, `BookingReport${currentDate}.pdf`);
  //         const downloadUrl = `${process.env.REACT_APP_URL}/files/Exported-Reports/report.pdf`;
  //         window.open(downloadUrl, "_blank");
  //         setLoading(false);
  //         setDownloadStatus("success");
  //       });
  //   } else {
  //     openSnackbar("No record to Export");
  //   }
  // };
  
  const createAndDownloadPdf = () => {
    setLoading(true);
  
    if (filteredRows.length) {
      setDownloadStatus("loading");
      // Enhance filteredRows with expense and commission descriptions
      const enhancedRows = filteredRows.map(row => ({
        ...row,
        expenseDescription: row.payable.map((item, index) => {
          const total = Number(item.unitPrice) * Number(item.quantity);
          return `(${index + 1}) ${item.itemName}, Total: ${total}`;
        }).join('\n'),
        commissionDescription: row.selling.map((item, index) => {
          const total = Number(item.unitPrice) * Number(item.quantity);
          return `(${index + 1}) ${item.itemName}, Total: ${total}`;
        }).join('\n')
      }));
  
      // Log raw and formatted dates for debugging
      console.log("Raw startDate:", startDate, "Type:", typeof startDate);
      console.log("Raw endDate:", endDate, "Type:", typeof endDate);
      console.log("startDate isValid:", startDate ? moment(startDate).isValid() : false);
      console.log("endDate isValid:", endDate ? moment(endDate).isValid() : false);
  
      // Format startDate and endDate
      const formattedStartDate = startDate && moment(startDate).isValid() 
        ? moment(startDate).format("DD-MM-YYYY") 
        : "N/A";
      const formattedEndDate = endDate && moment(endDate).isValid() 
        ? moment(endDate).format("DD-MM-YYYY") 
        : "N/A";
  
      console.log("Formatted startDate:", formattedStartDate);
      console.log("Formatted endDate:", formattedEndDate);
  
      axios
        .post(`${process.env.REACT_APP_API}/create-report`, {
          filteredRows: enhancedRows,
          users,
          searchQuery,
          profiles: profiles,
          startDate: formattedStartDate,
          endDate: formattedEndDate
        })
        .then(() =>
          axios.get(`${process.env.REACT_APP_API}/fetch-report`, {
            responseType: "blob",
          })
        )
        .then((res) => {
          const pdfBlob = new Blob([res.data], { type: "application/pdf" });
          const currentDate = new Date();
          saveAs(pdfBlob, `BookingReport${currentDate}.pdf`);
          const downloadUrl = `${process.env.REACT_APP_URL}/files/Exported-Reports/report.pdf`;
          window.open(downloadUrl, "_blank");
          setLoading(false);
          setDownloadStatus("success");
        })
        .catch((error) => {
          console.error("PDF export failed", error);
          openSnackbar("PDF export failed");
          setLoading(false);
          setDownloadStatus("error");
        });
    } else {
      openSnackbar("No record to Export");
      setLoading(false);
    }
  };
  const handleClientNameClick = (id) => {
    history.push(`/stats/${id}`);
  };
  if (!user) {
    history.push("/login");
  }

  const handleStartDateChange = (date) => {
    // const formattedDate = date.toISOString().split("T")[0];
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    // const formattedDate = date.toISOString().split("T")[0];
    setEndDate(date);
  };
  // const totalAmount = filteredRows.reduce((total, row) => {
  //   // Ensure that each row has an 'amount' property
  //   if (typeof row.total === "number") {
  //     return total + row.total;
  //   } else {
  //     return total;
  //   }
  // }, 0);
  const salespersonsProps = {
    options: users,
    getOptionLabel: (option) => option.name,
  };
  // }
  // function checkStatus(status) {
  //   return status === "Partial"
  //     ? {
  //         border: "solid 0px #1976d2",
  //         backgroundColor: "#baddff",
  //         padding: "8px 18px",
  //         borderRadius: "20px",
  //       }
  //     : status === "Paid"
  //     ? {
  //         border: "solid 0px green",
  //         backgroundColor: "#a5ffcd",
  //         padding: "8px 18px",
  //         borderRadius: "20px",
  //       }
  //     : status === "Unpaid"
  //     ? {
  //         border: "solid 0px red",
  //         backgroundColor: "#ffaa91",
  //         padding: "8px 18px",
  //         borderRadius: "20px",
  //       }
  //     : "red";
  // }

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          paddingTop: "20px",
        }}
      >
        <Spinner />
      </div>
    );
  }

  if (rows.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          paddingTop: "20px",
          margin: "80px",
        }}
      >
        <NoData />
        <p style={{ padding: "40px", color: "gray", textAlign: "center" }}>
          No Order yet. Click the plus icon to create Order
        </p>
      </div>
    );
  }
  const clientsProps = {
    options: clients,
    getOptionLabel: (option) => option.agentCode,
  };
  return (
    <div
      style={{
        minHeight: isMobile ? "740px" : "470px",
      }}
    >
      <ThemeProvider theme={colorTheme}>
        <Container
          style={{
            width: "100%" ,
            marginLeft: "80px",
            paddingTop: "2px",
            paddingBottom: "2px",
            border: "none",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              gap: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "10px",
              }}
            >
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  label="From"
                  name="FromDate"
                  value={startDate}
                  onChange={handleStartDateChange}
                  required
                  format="dd/MM/yyyy"
                  style={{ maxWidth: isMobile ? "50%" : "100%" }}
                />

                <KeyboardDatePicker
                  label="To"
                  name="EndDate"
                  value={endDate}
                  onChange={handleEndDateChange}
                  required
                  format="dd/MM/yyyy"
                  style={{ maxWidth: "50%" }}
                />
              </MuiPickersUtilsProvider>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "10px",
              }}
            >
              {user?.result?.userType === "admin" && (
                <FormControl style={{ width: "100px" }}>
                  <InputLabel>Filter:</InputLabel>
                  <Select
                    value={selectedFilter}
                    onChange={(event) => handleFilterChange(event)} // Provide the event object
                  >
                    <MenuItem value="salesperson">Filter by User</MenuItem>
                    <MenuItem value="customer">Filter by Agent</MenuItem>
                  </Select>
                  {selectedFilter && (
                    <IconButton
                      size="small"
                      style={{
                        marginLeft: "8px",
                        backgroundColor: "transparent",

                        color: "#ef7f1a",
                        borderRadius: "4px",
                      }}
                      onClick={() => {
                        setSelectedFilter("");
                        setSearchQuery("");
                        setSalesperson("");
                        setParty("");
                      }}
                    >
                      <ClearIcon />
                    </IconButton>
                  )}
                </FormControl>
              )}
              {selectedFilter && (
                <div>
                  {/* Display filtering results or perform filtering logic based on selectedFilter */}
                  {selectedFilter === "salesperson" ? (
                    <ThemeProvider theme={colorTheme}>
                      <Container>
                        {salesperson && (
                          <div
                            style={{
                              display: "flex",
                              marginTop: "20px",
                              gap: "5px",
                              height: "50px",
                            }}
                          >
                            <Typography variant="subtitle1" gutterBottom>
                              {salesperson.name}
                            </Typography>

                            <Button
                              color="primary"
                              size="small"
                              style={{
                                textTransform: "none",
                                backgroundColor: "#ef7f1a",
                                color: "white",
                              }}
                              onClick={() => {
                                setSalesperson(null);
                                setSearchQuery("");
                              }}
                            >
                              Change
                            </Button>
                          </div>
                        )}
                        <div
                          style={
                            salesperson
                              ? { display: "none" }
                              : { display: "block", width: "200px" }
                          }
                        >
                          <Autocomplete
                            {...salespersonsProps}
                            // PaperComponent={CustomPaper}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                // required={!invoice && true}
                                label="Select User"
                                margin="normal"
                                variant="outlined"

                                // error={touched && !!errors.client}
                                // helperText={touched && errors.client}
                              />
                            )}
                            value={users?.name}
                            onChange={(event, value) => {
                              setSalesperson(value);
                              setSearchQuery(value ? value.name : "");

                              console.log("value: ", value);
                              // handleClientChange();
                            }}
                            // onChange={(event, value) => setClient(value) }
                          />
                        </div>
                      </Container>
                    </ThemeProvider>
                  ) : selectedFilter === "customer" ? (
                    <ThemeProvider theme={colorTheme}>
                      <Container>
                        {party && (
                          <div
                            style={{
                              display: "flex",
                              marginTop: "20px",
                              gap: "10px",
                              height: "50px",
                            }}
                          >
                            <Typography variant="subtitle1" gutterBottom>
                              {party.agentCode}
                            </Typography>

                            <Button
                              color="primary"
                              size="small"
                              style={{
                                textTransform: "none",
                                backgroundColor: "#ef7f1a",
                                color: "white",
                              }}
                              onClick={() => {
                                setParty(null);
                                setSearchQuery("");
                              }}
                            >
                              Change
                            </Button>
                          </div>
                        )}
                        <div
                          style={
                            party
                              ? { display: "none" }
                              : { display: "block", width: "200px" }
                          }
                        >
                          <Autocomplete
                            {...clientsProps}
                            // PaperComponent={CustomPaper}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                // required={!invoice && true}
                                label="Select Agent/Hotel"
                                margin="normal"
                                variant="outlined"
                                // error={touched && !!errors.client}
                                // helperText={touched && errors.client}
                              />
                            )}
                            value={clients?.name}
                            onChange={(event, value) => {
                              setParty(value);
                              setSearchQuery(value ? value.agentCode : "");

                              // handleClientChange();
                            }}
                            // onChange={(event, value) => setClient(value) }
                          />
                        </div>
                      </Container>
                    </ThemeProvider>
                  ) : null}
                </div>
              )}
              {user?.result?.userType !== "admin" && (
                <ThemeProvider theme={colorTheme}>
                  <Container>
                    {party && (
                      <div
                        style={{
                          display: "flex",
                          marginTop: "20px",
                          gap: "10px",
                          height: "50px",
                        }}
                      >
                        <Typography variant="subtitle1" gutterBottom>
                          {party.agentCode}
                        </Typography>

                        <Button
                          color="primary"
                          size="small"
                          style={{
                            textTransform: "none",
                            backgroundColor: "#ef7f1a",
                            color: "white",
                          }}
                          onClick={() => {
                            setParty(null);
                            setSearchQuery("");
                          }}
                        >
                          Change
                        </Button>
                      </div>
                    )}
                    <div
                      style={
                        party
                          ? { display: "none" }
                          : { display: "block", width: "200px" }
                      }
                    >
                      <Autocomplete
                        {...clientsProps}
                        // PaperComponent={CustomPaper}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            // required={!invoice && true}
                            label="Select Hotel/Agent"
                            margin="normal"
                            variant="outlined"
                            // error={touched && !!errors.client}
                            // helperText={touched && errors.client}
                          />
                        )}
                        value={clients?.name}
                        onChange={(event, value) => {
                          setParty(value);
                          setSearchQuery(value ? value.agentCode : "");

                          // handleClientChange();
                        }}
                        // onChange={(event, value) => setClient(value) }
                      />
                    </div>
                  </Container>
                </ThemeProvider>
              )}

              {loading ? (
                <CircularProgress
                  style={{ marginTop: "20px", marginLeft: "10px" }}
                />
              ) : (
                user?.result?.userType === "admin" && (
                  <>
                  <Button
                    variant="outlined"
                    endIcon={<GetAppIcon />}
                    onClick={createAndDownloadPdf}
                    style={{
                      margin: "16px 0 8px 0",
                    }}
                  >
                    PDF
                  </Button>
                  <Button
                    variant="outlined"
                    endIcon={<GetAppIcon />}
                    onClick={createAndDownloadXlsx}
                    style={{
                      margin: "16px 0 8px 0",
                    }}
                  >
                    Excel
                  </Button>
                  </>
                  
                  
                )
              )}
            </div>
            {/* {((startDate && endDate) || salesperson || party) && (
              <div
                className={classes.textContainer}
                style={{ margin: isMobile ? "0" : "10px 0 0 2rem" }}
              >
                <Typography variant="h6" className={classes.typography}>
                  Total Bookings: {filteredRows.length}
                </Typography>

                <Typography variant="h6" className={classes.typography}>
                  Total Booking Amount: {format(totalAmount)}
                </Typography>
              </div>
            )} */}
          </div>

          <TableContainer component={Paper} elevation={0}>
            <Table
              className={classes.table}
              aria-label="custom pagination table"
            >
              <TableHead>
                <TableRow>
                  <TableCell style={headerStyle}>ID</TableCell>

                  <TableCell style={headerStyle}>Booking Date</TableCell>

                  {/* <TableCell style={headerStyle}>Hotel/Agent</TableCell> */}
                  <TableCell style={headerStyle}>Agent </TableCell>
                  <TableCell style={headerStyle}>Nationality</TableCell>
                  <TableCell style={headerStyle}>Hotel</TableCell>
                  <TableCell style={headerStyle}>Pax</TableCell>
                  <TableCell style={headerStyle}>Commission</TableCell>
                  <TableCell style={headerStyle}>Expense</TableCell>
                  <TableCell style={headerStyle}>Amount</TableCell>

                  {/* <TableCell style={headerStyle}>Status</TableCell> */}
                  {/* {user?.result?.userType === "admin" && (
                    <TableCell style={headerStyle}>User</TableCell>
                  )} */}

                  <TableCell style={headerStyle}>Edit</TableCell>

                  {user?.result?.userType === "admin" && (
                    <TableCell style={headerStyle}>Delete</TableCell>
                  )}
                </TableRow>
              </TableHead>

              <TableBody>
                {filteredRows.map((row) => (
                  <TableRow key={row._id} style={{ cursor: "pointer" }}>
                    <TableCell
                      style={tableStyle}
                      onClick={() => openInvoice(row._id)}
                    >
                      {" "}
                      {row.invoiceNumber}{" "}
                    </TableCell>
                    <TableCell
                      style={tableStyle}
                      onClick={() => openInvoice(row._id)}
                    >
                      {" "}
                      {moment(row.date).format("Do MMM YYYY")}{" "}
                    </TableCell>

                    {/* <TableCell
                      style={tableStyle}
                      // onClick={() => {
                      //   user?.result?.userType === "admin" &&
                      //     handleClientNameClick(row._id);
                      // }}
                    >
                      {" "}
                      {row.client.name?row.client.name:"Cash"}{" "}
                    </TableCell>
                     */}
                    <TableCell
                      style={tableStyle}
                      // onClick={() => {
                      //   user?.result?.userType === "admin" &&
                      //     handleClientNameClick(row._id);
                      // }}
                    >
                      {" "}
                      {row.client ? row.client.agentCode : "Cash"}{" "}
                    </TableCell>
                    <TableCell style={tableStyle}>{row.nationality}</TableCell>
                    <TableCell style={tableStyle}>{row.hotel}</TableCell>
                    <TableCell style={tableStyle}>{row.adult + row.child}</TableCell>
                    
                    <TableCell
                      style={tableStyle}
                      onClick={() => openInvoice(row._id)}
                    >
                      {row.currency}{" "}
                      {row.commission
                        ? toCommas(row.commission)
                        : row.commission}{" "}
                    </TableCell>
                    <TableCell
                      style={tableStyle}
                      onClick={() => openInvoice(row._id)}
                    >
                      {row.currency}{" "}
                      {row.expense ? toCommas(row.expense) : row.expense}{" "}
                    </TableCell>
                    <TableCell
                      style={tableStyle}
                      onClick={() => openInvoice(row._id)}
                    >
                      {row.currency}{" "}
                      {row.total ? toCommas(row.total) : row.total}{" "}
                    </TableCell>
                    {/* <TableCell style={tableStyle} onClick={() => openInvoice(row._id)}>
                    {" "}
                    {moment(row.dueDate).fromNow()}{" "}
                  </TableCell> */}
                    {/* <TableCell
                    style={tableStyle}
                  >
                    {" "}
                    <button style={checkStatus(row.status)}>
                      {row.status}
                    </button>
                  </TableCell> */}
                    {/* {user?.result?.userType === "admin" && (
                      <TableCell
                        style={tableStyle}
                        onClick={() => openInvoice(row._id)}
                      >
                        {" "}
                        {findUserNameById(row.creator)}{" "}
                       
                      </TableCell>
                    )} */}
                    {/* <TableCell style={tableStyle}>
                    {" "}
                    <IconButton onClick={() => openInvoice(row._id)}>
                      <RemoveRedEyeOutlinedIcon
                        style={{ width: "20px", height: "20px" }}
                      />
                    </IconButton>
                  </TableCell> */}

                    <TableCell style={{ ...tableStyle, width: "10px" }}>
                      <IconButton onClick={() => editInvoice(row._id)}>
                        <BorderColorIcon
                          style={{ width: "20px", height: "20px" }}
                        />
                      </IconButton>
                    </TableCell>

                    {user?.result?.userType === "admin" && (
                      <TableCell style={{ ...tableStyle, width: "10px" }}>
                        <IconButton onClick={() => handleDelete(row._id)}>
                          <DeleteOutlineRoundedIcon
                            style={{ width: "20px", height: "20px" }}
                          />
                        </IconButton>
                      </TableCell>
                    )}
                  </TableRow>
                ))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[
                      5,
                      10,
                      25,
                      { label: "All", value: totalInvoices },
                    ]}
                    colSpan={6}
                    count={totalInvoices}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    SelectProps={{
                      inputProps: { "aria-label": "rows per page" },
                      native: true,
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </Container>
      </ThemeProvider>
    </div>
  );
};

export default Invoices;
